module.exports = __webpack_public_path__ + "images/d34cc0fd25a88a5597cd2e48039ed341.png";